// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"11026817","795":"893a58ac","952":"f7617f79"}[chunkId] + ".chunk.css";
};